<template>
  <div class="ccp-wrapper">
    <input
      type="color"
      class="ccp-native"
      :value="sanitized"
      @input="onNativeInput"
    >
    <span class="ccp-preview" :style="{ background: sanitized }"></span>
    <input
      type="text"
      class="ccp-hex"
      :value="value"
      maxlength="7"
      spellcheck="false"
      @input="onHexInput"
      @blur="onHexBlur"
    >
  </div>
</template>

<script>
const HEX_RE = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/

export default {
  name: 'CompactColorPicker',
  props: {
    value: { type: String, default: '#000000' }
  },
  computed: {
    // Native <input type="color"> only accepts 6-digit hex
    sanitized() {
      if (HEX_RE.test(this.value)) {
        if (this.value.length === 4) {
          const v = this.value
          return '#' + v[1] + v[1] + v[2] + v[2] + v[3] + v[3]
        }
        return this.value
      }
      return '#000000'
    }
  },
  methods: {
    onNativeInput(e) {
      this.$emit('input', e.target.value)
    },
    onHexInput(e) {
      const v = e.target.value
      // Pass through raw typing, but only emit for valid hex so parent state stays clean.
      if (HEX_RE.test(v)) {
        this.$emit('input', v)
      } else if (HEX_RE.test('#' + v)) {
        this.$emit('input', '#' + v)
      }
    },
    onHexBlur(e) {
      // Normalize on blur: restore a valid hex so the input matches current value.
      if (!HEX_RE.test(e.target.value)) {
        e.target.value = this.value
      }
    }
  }
}
</script>

<style scoped>
.ccp-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: #f1f5f9;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.ccp-wrapper:hover {
  border-color: #cbd5e1;
}

.ccp-wrapper:focus-within {
  border-color: #4c5c8a;
}

.ccp-native {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  opacity: 0;
  cursor: pointer;
}

.ccp-preview {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12) inset;
  cursor: pointer;
  flex-shrink: 0;
  pointer-events: none;
}

.ccp-hex {
  flex: 1;
  min-width: 80px;
  border: none;
  background: transparent;
  font-family: 'Menlo', 'Consolas', monospace;
  font-size: 13px;
  color: #334155;
  text-transform: uppercase;
  padding: 0;
}

.ccp-hex:focus {
  outline: none;
}
</style>
